import React from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';
import {
  Heading1, Paragraph, Input, LinkButton,
} from '../components/typography';
import { Container, Row, Col } from '../components/grid';
import { sanitizePrice } from '../lib/price';
import getArg from '../lib/args';
import getPaymentWindow from '../lib/payment';
import { ScreenSizeDetector } from '../lib/helpers';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';


export class Betaling extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasSetProps: false,
      name: '',
      amount: '',
    };
    this.onClick = this.onClick.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeAmount = this.onChangeAmount.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.hasSetProps) {
      return {};
    }
    const {
      location: {
        search,
      },
    } = nextProps;
    const args = queryString.parse(search);
    return {
      name: args.faknr || '',
      amount: args.belob || '',
      instantCapture: typeof args.haevikke === 'undefined',
      hasSetProps: true,
    };
  }

  onChangeName({ target: { value: name } }) {
    this.setState({ name });
  }

  onChangeAmount({ target: { value: amount } }) {
    this.setState({ amount });
  }

  onClick() {
    const {
      name,
      amount,
      instantCapture,
    } = this.state;
    const parsedAmount = sanitizePrice(amount.replace(/[.]/g, '').replace(',', '.'));
    if (Number.isNaN(parsedAmount)) {
      window.alert('Det indtastede beløb er ikke et tal'); // eslint-disable-line
      return;
    }
    if (parsedAmount === 0) {
      window.alert('Det indtastede beløb må ikke være 0'); // eslint-disable-line
      return;
    }
    const origin = window.location.origin; // eslint-disable-line
    if (origin.indexOf('localhost') === -1) {
      const paymentwindowProps = {
        orderid: name.trim(),
        merchantnumber: getArg('epayMerchantNumber'),
        amount: Math.round(parsedAmount * 100),
        currency: 'DKK',
        paymentcollection: 0,
        mobile: '1',
        ownreceipt: 1,
        instantcapture: instantCapture ? '1' : '0',
      };
      if (origin.indexOf('localhost') === -1) { // eslint-disable-line
        paymentwindowProps.accepturl = `${origin}/betaling/success`;
      }
      getPaymentWindow(
        (PaymentWindow) => {
          const paymentwindow = new PaymentWindow(paymentwindowProps);
          paymentwindow.open();
          window.scrollTo(0, 0); // eslint-disable-line
        },
      );
    } else {
      const { history } = this.props;
      history.push(`/betaling/success?amount=${
        Math.round(parsedAmount * 100)
      }&orderid=${
        name.trim()
      }&txnid=OrderTranskationsID222&date=${
        moment().format('YYYYMMDD')
      }&time=${
        moment().format('HHMM')
      }`);
    }
  }

  render() {
    const {
      name,
      amount,
    } = this.state;
    return (
      <SidemenuLayout menuPicker="Infosider" activeSidemenu="Betal">
        <Container white>
          <Row>
            <Col xs={12} textCenter>
              <Heading1>
                Betal med betalingskort
              </Heading1>
              <Paragraph>
                Betal online. Vi modtager følgende betalingskort:
              </Paragraph>
              <Paragraph>
                <ScreenSizeDetector width={[[400, '50px'], '60px']}>
                  <img src="/svg/mobilepay.svg" alt="MobilePay" />
                  <img src="/svg/dankort.svg" alt="Dankort" />
                  <img src="/svg/visa.svg" alt="Visa" />
                  <img src="/svg/mastercard.svg" alt="MasterCard" />
                  <img src="/svg/maestro.svg" alt="Maestro" />
                </ScreenSizeDetector>
              </Paragraph>
              <Paragraph fontSize="12px">
                Kortgebyr tillægges firma og udenlandske kort
              </Paragraph>
              <Input placeholder="Faktura nr. / Navn" width="260px" type="text" fontSize="16px" onChange={this.onChangeName} value={name} /><br /><br />
              <Input placeholder="Beløb" type="text" width="260px" fontSize="16px" onChange={this.onChangeAmount} value={amount} /><br /><br />
              <LinkButton action onClick={this.onClick} justifyCenter creditcard>
                Betal beløb
              </LinkButton>
            </Col>
          </Row>
        </Container>
      </SidemenuLayout>
    );
  }
}

export default withRouter(Betaling);
